module.exports = __webpack_public_path__ + "img/baggage-solid.c3bc46d8.svg";